import {
  Box,
  BlockStack,
  InlineGrid,
  Text,
  Card,
  Divider,
  useBreakpoints,
  TextField,
  Button,
  ChoiceList,
  Avatar,
  InlineStack,
  Spinner,
  ButtonGroup,
  Icon,
  Toast,
  Badge,
  Tabs,
  Tag,
  Autocomplete,
  Banner,
} from '@shopify/polaris';
import {
  SettingsIcon,
  EditIcon,
  CheckIcon,
  ExternalIcon,
  LogoGoogleIcon
} from '@shopify/polaris-icons'
import { doc, setDoc } from 'firebase/firestore';
import { useEffect, useState, useCallback } from 'react';

import ChooseASubscriptionPanel from '../components/ChooseASubscriptionPanel';
import AppLayout from '../components/layout';
import PostsLibrary from '../components/PostsLibrary';

// import TremendousPanel from '../components/TremendousPanel';
import { usePartnerUp } from '../providers/PartnerUpStoreProvider';

export const countryCodes = [
  {
    "id": 148838,
    "name": "United States",
    "title": "United States"
  },
  {
    "id": 2202162,
    "name": "France",
    "title": "France"
  },
  {
    "id": 60189,
    "name": "Russia",
    "title": "Russia"
  },
  {
    "id": 1428125,
    "name": "Canada",
    "title": "Canada"
  },
  {
    "id": 1311341,
    "name": "Spain",
    "title": "Spain"
  },
  {
    "id": 62149,
    "name": "United Kingdom",
    "title": "United Kingdom"
  },
  {
    "id": 59470,
    "name": "Brazil",
    "title": "Brazil"
  },
  {
    "id": 114686,
    "name": "Mexico",
    "title": "Mexico"
  },
  {
    "id": 51477,
    "name": "Germany",
    "title": "Germany"
  },
  {
    "id": 365331,
    "name": "Italy",
    "title": "Italy"
  },
  {
    "id": 174737,
    "name": "Turkey",
    "title": "Turkey"
  },
  {
    "id": 304716,
    "name": "India",
    "title": "India"
  },
]

// This example is for guidance purposes. Copying it will come with caveats.
export default function Settings() {
  const {
    db,
    store,
    refetchStore,
    openBeacon,
    uploadFile,
    leads,
    pastPayments,
    user,
    refetchUser
  } = usePartnerUp();
  const { smUp, mdDown } = useBreakpoints();

  const [settingsTab, setSettingsTab] = useState(0)
  const [localStore, setLocalStore] = useState(store);
  const [localUser, setLocalUser] = useState(user);
  const [editingContactEmail, setEditingContactEmail] = useState(false);
  const [editingBasicInfo, setEditingBasicInfo] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [customDomainModalOpen, setCustomDomainModalOpen] = useState(false);
  const [toast, setToast] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false)

  const [localFilters, setLocalFilters] = useState(user?.filters || {
    ageGroups: [],
    genders: [],
    countries: []
  })

  const [logoFile, setLogoFile] = useState(null);
  const [squareLogoFile, setSquareLogoFile] = useState(null);


  useEffect(() => {
    if (store) {
      setLocalStore(store)
    }
  }, [store])

  useEffect(() => {
    if (user) {
      setLocalUser(user)
      if (user?.filters) {
        setLocalFilters(user?.filters)
      }
    }
  }, [user])

  const toggleActive = useCallback(() => setToast(null), []);
  const toastMarkup = toast ? (
    <Toast content={toast.content} error={toast.isError} onDismiss={toggleActive} />
  ) : null;

  console.log('user is', user)
  async function saveStore() {
    try {
      setSaveLoading(true)
      await setDoc(doc(db, 'stores', store.id), localStore)
      setLocalStore(store)
      refetchStore()
      setToast({ content: 'Saved!' })
    } catch (e) {
      setToast({ content: 'Error saving. Please try again.', isError: true })
      console.error(e)
    } finally {
      setSaveLoading(false)
    }
  }

  async function saveUser() {
    try {
      setSaveLoading(true)
      await setDoc(doc(db, 'users', user.id), localUser)
      setLocalUser(user)
      refetchUser()
      setToast({ content: 'Saved!' })
    } catch (e) {
      setToast({ content: 'Error saving. Please try again.', isError: true })
      console.error(e)
    } finally {
      setSaveLoading(false)
    }

  }

  useEffect(() => {
    if (logoFile) {
      setUploadLoading(1)
      uploadFile(logoFile, 'logo').then(async url => {
        setUploadLoading(null)
        await setDoc(doc(db, 'stores', store.id), { logo: url }, { merge: true })
        refetchStore()
        setToast({ content: 'Logo uploaded!' })
      }).catch(e => {
        setUploadLoading(null)
        console.error(e)
        setToast({ content: 'Error uploading. Please try again.', isError: true })
      })
    }
  }, [logoFile])

  useEffect(() => {
    if (squareLogoFile) {
      setUploadLoading(2)
      uploadFile(squareLogoFile, 'squareLogo').then(async url => {
        setUploadLoading(null)
        await setDoc(doc(db, 'users', user.id), { vatar: url }, { merge: true })
        refetchUser()
        setToast({ content: 'Avatar uploaded!' })
      }).catch(e => {
        setUploadLoading(null)
        console.error(e)
        setToast({ content: 'Error uploading. Please try again.', isError: true })
      })
    }
  }, [squareLogoFile])

  function exportAllCreators() {
    const csvContent = "data:text/csv;charset=utf-8," + "Email,Name,Platform,Handle,URL,Bio,Country,Age Group,Engagement Rate,Average Views,Fake Followers\n" +
      leads.map(lead => {
        console.log('lead is', lead?.profile?.audience?.credibility)
        const platform = lead?.platform || lead?.profile?.platform
        const handle = lead?.handle || lead?.profile?.handle || lead?.profile?.profile?.username || lead?.profile?.profile?.handle
        const url = lead?.profile?.profile?.url || (platform && handle ? `https://www.${platform}.com/${platform === 'tiktok' || platform === 'youtube' ? '@' : ''}${handle}` : '-')
        return `${lead?.email || lead?.profile?.contacts?.find(c => c?.type === 'email')?.value || '-'},${lead?.name || lead?.profile?.fullname || '-'},${platform || '-'},${handle || '-'},${url || '-'},${lead?.profile?.bio?.replaceAll(',', '')?.replaceAll('\n', '') || '-'},${lead?.profile?.country || '-'},${lead?.profile?.ageGroup || '-'},${(lead?.profile?.profile?.engagementRate ? (lead?.profile?.profile?.engagementRate * 100).toFixed(2) + '%' : '-')},${lead?.profile?.avgReelsPlays || lead?.profile?.profile?.averageViews || '-'},${lead?.profile?.audience?.credibility ? ((1 - lead?.profile?.audience?.credibility) * 100).toFixed(2) + '%' : '-'}`
      }).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "partnerup-creators.csv");
    document.body.appendChild(link); // Required for FF
    link.click();
  }

  console.log('user is', user)

  return (
    <AppLayout>
      <InlineStack align="center">
        <Box maxWidth="1500px" width="1500px">
          <BlockStack
            gap="500"
          >
            <InlineStack align="space-between">
              <InlineStack gap="300" blockAlign="center">
                <InlineStack>
                  <Icon source={SettingsIcon} />
                </InlineStack>
                <Text variant="headingXl">Account</Text>
              </InlineStack>
            </InlineStack>
            <Tabs tabs={[
              { id: 'settings', content: 'Settings' },
              // { id: 'data-export', content: 'Data Export' },
            ]} selected={settingsTab} onSelect={setSettingsTab} />
            {toastMarkup}
            {
              settingsTab === 2 ? (
                <PostsLibrary creatorPosts={[]} />
              ) : settingsTab === 1 ? (
                <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                  <Box
                    as="section"
                    paddingInlineStart={{ xs: 4, sm: 0 }}
                    paddingInlineEnd={{ xs: 4, sm: 0 }}
                  >
                    <BlockStack gap="400">
                      <Text as="h3" variant="headingXl">
                        Export Your Data
                      </Text>
                      <Text as="p" variant="bodyMd">
                        Choose the data you want to export
                      </Text>
                    </BlockStack>
                  </Box>
                  <InlineGrid gap="300" columns={{ xs: "1", md: "3" }}>
                    <Card>
                      <BlockStack gap="300">
                        <InlineStack align="space-between">
                          <Text variant="headingMd">Export Creators</Text>
                          <Button icon={ExternalIcon} plain />
                        </InlineStack>
                        <Divider />
                        <BlockStack gap="200">
                          <Text>Export all your Creators</Text>
                          <Button onClick={exportAllCreators}>Export</Button>
                        </BlockStack>
                      </BlockStack>
                    </Card>
                  </InlineGrid>
                </InlineGrid>
              ) : (
                <div style={{ marginBottom: '100px' }}>
                  <BlockStack gap={{ xs: "800", sm: "1600" }}>
                    <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                      <Box
                        as="section"
                        paddingInlineStart={{ xs: 4, sm: 0 }}
                        paddingInlineEnd={{ xs: 4, sm: 0 }}
                      >
                        <BlockStack gap="400">
                          <Text as="h3" variant="headingXl">
                            Basic Info
                          </Text>
                          <Text as="p" variant="bodyMd">
                            About you
                          </Text>
                        </BlockStack>
                      </Box>
                      <BlockStack gap="300">
                        <InlineGrid columns={{ xs: "1", md: "3" }} gap="200" align="space-between" blockAlign="start">
                          <Card roundedAbove="sm">
                            <BlockStack gap="300" align="center">
                              <InlineStack align="space-between">
                                <Text variant="headingMd">Google Account</Text>
                              </InlineStack>
                              <Divider />
                              {
                                editingBasicInfo ? (
                                  <>
                                    <TextField label="Name" value={localUser?.name} onChange={(value) => {
                                      setLocalUser({
                                        ...localUser,
                                        name: value
                                      })
                                    }} />
                                    <ButtonGroup>
                                      <Button loading={saveLoading}
                                        onClick={async () => {
                                          await saveUser()
                                          setEditingBasicInfo(false)
                                        }} primary>Save</Button>
                                      <Button onClick={() => {
                                        setEditingBasicInfo(false)
                                        setLocalUser(user)
                                      }} color="subdued">Cancel</Button>
                                    </ButtonGroup>
                                  </>
                                ) : (
                                  <BlockStack gap="400">
                                    <BlockStack>
                                      <Text variant="bodySm" color="subdued">Name</Text>
                                      <Text>{localUser?.name}</Text>
                                    </BlockStack>
                                  </BlockStack>
                                )
                              }
                            </BlockStack>
                          </Card>
                          <Card roundedAbove="sm">
                            <BlockStack gap="300" align="center">
                              <InlineStack align="space-between">
                                <Text variant="headingMd">User</Text>
                                <Button icon={EditIcon} plain onClick={() => setEditingBasicInfo(true)} />
                              </InlineStack>
                              <Divider />
                              {
                                editingBasicInfo ? (
                                  <>
                                    <TextField label="Name" value={localUser?.name} onChange={(value) => {
                                      setLocalUser({
                                        ...localUser,
                                        name: value
                                      })
                                    }} />
                                    <ButtonGroup>
                                      <Button loading={saveLoading}
                                        onClick={async () => {
                                          await saveUser()
                                          setEditingBasicInfo(false)
                                        }} primary>Save</Button>
                                      <Button onClick={() => {
                                        setEditingBasicInfo(false)
                                        setLocalUser(user)
                                      }} color="subdued">Cancel</Button>
                                    </ButtonGroup>
                                  </>
                                ) : (
                                  <BlockStack gap="400">
                                    <BlockStack>
                                      <Text variant="bodySm" color="subdued">Name</Text>
                                      <Text>{localUser?.name}</Text>
                                    </BlockStack>
                                  </BlockStack>
                                )
                              }
                            </BlockStack>
                          </Card>
                          <Card roundedAbove="sm">
                            <BlockStack gap="300" align="center">
                              <Text variant="headingMd">Company</Text>
                              <Divider />
                              {
                                editingContactEmail ? (
                                  <BlockStack gap="100">
                                    <TextField label="Brand Name" value={localStore?.sendFrom || localStore?.name} onChange={(value) => {
                                      setLocalStore({
                                        ...localStore,
                                        name: value
                                      })
                                    }} />
                                    <ButtonGroup>
                                      <Button loading={saveLoading}
                                        onClick={async () => {
                                          await saveStore()
                                          setEditingContactEmail(false)
                                        }} primary>Save</Button>
                                      <Button onClick={() => {
                                        setLocalStore(store)
                                        setEditingContactEmail(false)
                                      }} color="subdued">Cancel</Button>
                                    </ButtonGroup>
                                  </BlockStack>
                                ) : (
                                  <BlockStack gap="300">
                                    <BlockStack>
                                      <Text variant="bodySm">Company Name</Text>
                                      <Text>{user?.brand}</Text>
                                    </BlockStack>
                                  </BlockStack>
                                )
                              }
                            </BlockStack>
                          </Card>
                        </InlineGrid>
                      </BlockStack>
                    </InlineGrid>
                    {smUp ? <Divider /> : null}
                    <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                      <Box
                        as="section"
                        paddingInlineStart={{ xs: 4, sm: 0 }}
                        paddingInlineEnd={{ xs: 4, sm: 0 }}
                      >
                        <BlockStack gap="400">
                          <Text as="h3" variant="headingXl">
                            Target Customers
                          </Text>
                          <Text as="p" variant="bodyMd">
                            Calculate Qualified Followers
                          </Text>
                        </BlockStack>
                      </Box>
                      <BlockStack gap="300">
                        <Banner tone="success" icon={LogoGoogleIcon} status="info" onDismiss={() => {

                        }}>
                          <BlockStack gap="200">
                            <Text>
                              Install the PartnerUp Chrome Extension to save creators directly from Instagram, TikTok, and YouTube.
                            </Text>
                            <ButtonGroup>
                              <Button
                                target="_blank"
                                url={
                                  "https://chromewebstore.google.com/detail/partnerup/ndmiddpkpghkflllbklblbgiofimjfck"
                                }>Install Extension</Button>
                            </ButtonGroup>
                          </BlockStack>
                        </Banner>
                        <InlineGrid columns={{ xs: "1", md: "1" }} gap="200" align="space-between" blockAlign="start">
                          <Card roundedAbove="sm">
                            <BlockStack gap="500">
                              <Banner status="info" >
                                <Text>If "Any" is Ok, Remove the Filter</Text>
                              </Banner>
                              <InlineGrid gap="200" columns={{ xs: "1", md: "3" }}>
                                <Autocomplete
                                  allowMultiple
                                  onSelect={(value) => {
                                    const newValue = value.pop()
                                    setLocalFilters({
                                      ...localFilters,
                                      ageGroups: [...localFilters.ageGroups, newValue]
                                    })
                                  }}
                                  label="Ages"
                                  options={[
                                    { label: '13-17', value: '13-17' },
                                    { label: '18-24', value: '18-24' },
                                    { label: '25-34', value: '25-34' },
                                    { label: '35-44', value: '35-44' },
                                    { label: '45-64', value: '45-64' },
                                    { label: '65+', value: '65-' }
                                  ].filter(i => !(localFilters.ageGroups?.includes(i.value) === true))}
                                  selected={localFilters.ageGroups || []}
                                  textField={
                                    <Autocomplete.TextField
                                      placeholder={localFilters?.ageGroups?.length > 5 ? '' : localFilters?.ageGroups?.length > 0 ? "Add Age" : "Any"}
                                      label="Ages"
                                      value={''}
                                      autoComplete="off"
                                      verticalContent={
                                        localFilters?.ageGroups?.length > 0 ? (
                                          <InlineStack gap="3" align="start">
                                            {
                                              localFilters.ageGroups?.map(age => {
                                                return (
                                                  <Tag key={age} onRemove={
                                                    () => {
                                                      setLocalFilters({
                                                        ...localFilters,
                                                        ageGroups: localFilters.ageGroups.filter(i => i !== age)
                                                      })
                                                    }
                                                  }>{age}
                                                  </Tag>
                                                )
                                              })
                                            }
                                          </InlineStack>
                                        ) : null
                                      }
                                    />
                                  }
                                />
                                <Autocomplete
                                  allowMultiple
                                  onSelect={(value) => {
                                    const newValue = value.pop()
                                    setLocalFilters({
                                      ...localFilters,
                                      genders: [...localFilters.genders, newValue]
                                    })
                                  }}
                                  label="Gender"
                                  options={[
                                    { label: 'Male', value: 'MALE' },
                                    { label: 'Female', value: 'FEMALE' },
                                  ].filter(i => !(localFilters.genders?.includes(i.value) === true))}
                                  selected={localFilters.genders || []}
                                  textField={
                                    <Autocomplete.TextField
                                      placeholder={localFilters?.genders?.length > 1 ? '' : localFilters?.genders?.length > 0 ? "Add Gender" : "Any"}
                                      label="Genders"
                                      value={''}
                                      autoComplete="off"
                                      verticalContent={
                                        localFilters?.genders?.length > 0 ? (
                                          <InlineStack gap="3" align="start">
                                            {
                                              localFilters?.genders?.map(gender => {
                                                return (
                                                  <Tag onRemove={
                                                    () => {
                                                      setLocalFilters({
                                                        ...localFilters,
                                                        genders: localFilters.genders.filter(i => i !== gender)
                                                      })
                                                    }}>
                                                    {gender}
                                                  </Tag>
                                                )
                                              })
                                            }
                                          </InlineStack>
                                        ) : null
                                      }
                                    />
                                  }
                                />
                                <Autocomplete
                                  allowMultiple
                                  onSelect={(value) => {
                                    const newValue = value.pop()
                                    setLocalFilters({
                                      ...localFilters,
                                      countries: [...localFilters.countries, newValue]
                                    })
                                  }}
                                  label="Countries"
                                  options={countryCodes?.map(c => {
                                    return {
                                      label: c.name,
                                      value: c.name
                                    }
                                  }).filter(i => !(localFilters.countries?.includes(i.value) === true))}
                                  selected={localFilters.countries || []}
                                  textField={
                                    <Autocomplete.TextField
                                      placeholder={localFilters?.countries?.length > 0 ? "Add Country" : "Any"}
                                      label="Countries"
                                      value={''}
                                      autoComplete="off"
                                      verticalContent={
                                        localFilters?.countries?.length > 0 ? (
                                          <InlineStack gap="3" align="start">
                                            {
                                              localFilters?.countries?.map(country => {
                                                return (
                                                  <Tag onRemove={
                                                    () => {
                                                      setLocalFilters({
                                                        ...localFilters,
                                                        countries: localFilters.countries.filter(i => i !== country)
                                                      })
                                                    }}>
                                                    {country}
                                                  </Tag>
                                                )
                                              })
                                            }
                                          </InlineStack>
                                        ) : null
                                      }
                                    />
                                  }
                                />
                              </InlineGrid>
                              <InlineStack align="end">
                                <Button onClick={async () => {
                                  try {
                                    await setDoc(doc(db, 'usersV2', user.id), { filters: localFilters }, { merge: true })
                                    setToast({ content: 'Saved!' })
                                  } catch (e) {
                                    setToast({ content: 'Error saving. Please try again.', isError: true })
                                  }
                                }}>Save</Button>
                              </InlineStack>
                            </BlockStack>
                          </Card>
                        </InlineGrid>
                      </BlockStack>
                    </InlineGrid>
                    {smUp ? <Divider /> : null}
                    <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                      <Box
                        as="section"
                        paddingInlineStart={{ xs: 4, sm: 0 }}
                        paddingInlineEnd={{ xs: 4, sm: 0 }}
                      >
                        <BlockStack gap="400">
                          <Text as="h3" variant="headingXl">
                            Support
                          </Text>
                          <Text as="p" variant="bodyMd">
                            Contact Us
                          </Text>
                        </BlockStack>
                      </Box>
                      <BlockStack gap="200">
                        <InlineGrid columns={{ xs: "1", md: "2" }} gap="300">
                          <Card>
                            <BlockStack gap="400" inlineAlign="center">
                              <Box />
                              <Text variant="headingXl">Get Help & Support</Text>
                              <Button onClick={openBeacon}>Send us a Message</Button>
                              <Text>Or, Email support@partnerup.net</Text>
                            </BlockStack>
                          </Card>
                        </InlineGrid>
                      </BlockStack>
                    </InlineGrid>
                  </BlockStack>
                </div>
              )
            }
          </BlockStack>
        </Box>
      </InlineStack>
    </AppLayout>
  );
}
